// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"MN-z","categoryName":"NN-z","categoryNameSearchHeader":"ON-z","categoryContent":"PN-z","bottomAligned":"QN-z","image":"RN-z","imageNoBackground":"SN-z"};